import React, { useState, useEffect } from 'react';
import { Modal, Button, Alert, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  obterSolicitaDebMunicipio,
  gerarRequerimentoSolicitaDebMunicipio,
} from '~/Services/Service';

const GerarRequerimentoModal = ({ show, onHide, solicitacao, onSuccess }) => {
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [gerando, setGerando] = useState(false);

  useEffect(() => {
    if (show && solicitacao && solicitacao.codigo) {
      carregarDados(solicitacao.codigo);
    } else {
      setDados(null);
    }
  }, [show, solicitacao && solicitacao.codigo]); // eslint-disable-line

  const carregarDados = async (codigo) => {
    setCarregando(true);
    try {
      const resp = await obterSolicitaDebMunicipio(codigo);
      setDados(resp || null);
    } catch (err) {
      toast.error('Falha ao carregar dados da solicitação.');
    } finally {
      setCarregando(false);
    }
  };

  const handleGerar = async () => {
    if (!solicitacao) return;
    setGerando(true);
    try {
      const resp = await gerarRequerimentoSolicitaDebMunicipio(solicitacao.codigo);
      const url = resp && resp.url_pdf ? resp.url_pdf : null;
      if (url) {
        window.open(url, '_blank');
      }
      toast.success('Requerimento gerado com sucesso.');
      if (onSuccess) onSuccess();
      onHide();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setGerando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
          Gerar Requerimento de IPTU
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {carregando ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2 text-muted">Carregando dados...</p>
          </div>
        ) : dados ? (
          <div style={{ fontSize: '0.9rem' }}>
            <p className="text-muted mb-3">
              Será gerado um PDF de requerimento formal de exclusão de dados do cadastro de IPTU
              endereçado à Prefeitura, com os dados abaixo.
            </p>
            <dl className="row mb-0">
              <dt className="col-sm-4">Solicitação</dt>
              <dd className="col-sm-8">#{dados.codigo}</dd>
              <dt className="col-sm-4">Boleto</dt>
              <dd className="col-sm-8">{dados.codigo_boleto}</dd>
              <dt className="col-sm-4">Cliente</dt>
              <dd className="col-sm-8">{dados.cliente_nome}</dd>
              <dt className="col-sm-4">Tipo</dt>
              <dd className="col-sm-8">{dados.tipo_solicitacao}</dd>
              {dados.nome_grupo_empresa && (
                <>
                  <dt className="col-sm-4">Empreendimento</dt>
                  <dd className="col-sm-8">{dados.nome_grupo_empresa}</dd>
                </>
              )}
            </dl>
            {dados.tem_requerimento && (
              <Alert variant="warning" className="mt-3 py-2" style={{ fontSize: '0.85rem' }}>
                Esta solicitação já possui um requerimento gerado. Gerar novamente irá substituí-lo.
              </Alert>
            )}
          </div>
        ) : (
          <p className="text-muted">Nenhuma solicitação selecionada.</p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={gerando}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleGerar}
          disabled={!dados || gerando || carregando}
        >
          {gerando ? 'Gerando...' : 'Gerar PDF'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GerarRequerimentoModal;
